import PromoAlertSearch from '../promo/PromoAlertSearch';

const CityRinkSearch = props => <PromoAlertSearch {...props} campaignType="City Rink" />;

export default CityRinkSearch;
